import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, NavigationSkipped, Router } from '@angular/router';
import { BaseViewComponent, Environment, WebsiteBlockTypeData, WebsiteMode } from '@sb/library/base';
import { WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockType, WebsiteRenderMode } from '@sb/library/data-models';
import { pageNotFoundID } from '@shared/definitions/website.definitions';
import { WebsitePortalScope } from './app-bootstrap.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseViewComponent {
    readonly Scope = this.SetScope({
        Requires: WebsitePortalScope
    });

    readonly WebsiteRenderMode = WebsiteRenderMode;
    readonly WebsiteMode = WebsiteMode;
    readonly currentYear = new Date().getFullYear();

    private _currentViewablePageID!: string;

    constructor(
        private _Location: Location,
        private _Environment: Environment,
        private _Router: Router
    ) {
        super();

        switch (this.Scope.renderContext.RenderMode) {
            case WebsiteRenderMode.Website:
                this.SubscribeToNavigationEnd();
                break;
            case WebsiteRenderMode.Widget:
                document.body.style.overflow = 'hidden';
                break;
        }
    }

    NavigationPageClicked(id: string): void {
        const [path, title] = this.Scope.pathAndTitleByID[id];
        this._Location.go(path);
        document.title = title;

        this._currentViewablePageID = id;
    }

    private SubscribeToNavigationEnd() {
        this._subscriptions.push(this._Router.events.subscribe(event => {
            if (event instanceof NavigationEnd || event instanceof NavigationSkipped) {
                const [path] = event.url.split('?');
                const pageIDFromPath = this.Scope.idByPath[path.toLowerCase()];
                this._currentViewablePageID = pageIDFromPath ?? pageNotFoundID;
            }
        }));
    }

    IsHeroBlock(blockType: WebsiteBlockTypeData): boolean {
        return blockType.BlockType === WebsiteBlockType.TextAndMedia && WebsiteBlockTextAndMediaDisplayItem.IsHeroBlock({ TextAndMediaType: blockType.BlockSubtype} as WebsiteBlockTextAndMediaDisplayItem)
    }

    get currentViewablePageID(): string {
        return this._currentViewablePageID;
    }

    get hostname(): string {
        return `https://${this._Environment.Application.Hostname}`;
    }
}
